<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import WechatOfficialAccountManage from "./WechatOfficialAccountManage.vue";

export default {
  page() {
    return {
      title: this.title,
      meta: [{ name: "description" }],
    };
  },
  components: { Layout, PageHeader, WechatOfficialAccountManage },
  data() {
    return {
      title: "",
      items: [],
    };
  },
  mounted() {
    this.title = this.$t("menuitems.wechat.wechatmp.text");
    this.items = [
      { text: this.$t("menuitems.wechat.text"), href: "/" },
      { text: this.$t("menuitems.wechat.wechatmp.text"), active: true },
    ];
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <WechatOfficialAccountManage />
      </div>
    </div>
  </Layout>
</template>
